import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme';
import { mq } from '@/theme/scalingTokens';

export const useInfoRowStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap(tokens.spacingVerticalXXS),
    ...shorthands.padding('0'),
  },
  /**
   * Figma 2026 InfoRow (Review summary side-by-side grid): two-column
   * label + value layout at ≥ 768 px, single column below.
   */
  rootFigma: {
    display: 'grid',
    gridTemplateColumns: 'minmax(8rem, auto) 1fr',
    columnGap: tokens.spacingHorizontalL,
    rowGap: tokens.spacingVerticalXXS,
    ...shorthands.padding(tokens.spacingVerticalXXS, '0'),
    [mq.mobile]: {
      gridTemplateColumns: '1fr',
      rowGap: tokens.spacingVerticalXXS,
    },
  },
  labelFigma: {
    fontSize: fontScale.caption,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground3,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
  },
  valueFigma: {
    fontSize: fontScale.body,
    color: tokens.colorNeutralForeground1,
    wordBreak: 'break-word',
  },
  rootInline: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'baseline',
    ...shorthands.gap(tokens.spacingHorizontalSNudge),
    ...shorthands.padding(tokens.spacingVerticalXXS, '0'),
  },
  label: {
    fontSize: fontScale.body,
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: tokens.lineHeightBase300,
    color: tokens.colorNeutralForeground1,
  },
  value: {
    fontSize: fontScale.body,
    fontWeight: tokens.fontWeightRegular,
    lineHeight: tokens.lineHeightBase300,
    color: tokens.colorNeutralForeground1,
    wordBreak: 'break-word',
  },
  link: {
    color: tokens.colorBrandForegroundLink,
    textDecorationLine: 'none',
    ':hover': {
      textDecorationLine: 'underline',
    },
    ':focus-visible': {
      outlineStyle: 'solid',
      outlineWidth: '2px',
      outlineColor: tokens.colorStrokeFocus2,
      ...shorthands.borderRadius(tokens.borderRadiusSmall),
    },
  },
  notProvided: {
    color: tokens.colorNeutralForeground4,
    fontStyle: 'italic',
  },
});
